export default __webpack_public_path__ + "static/media/D-Wallet.d0dc1e2c.apk";